import {
  FaMobileAlt,
  FaLaptop,
  FaTshirt,
  FaHome,
  FaGamepad,
  FaSpa,
} from "react-icons/fa";

const categories = [
  {
    icon: <FaMobileAlt />,
    title: "Mobiles",
    subtitle: "Smart Phones",
    bg: "bg-yellow-200",
  },
  {
    icon: <FaLaptop />,
    title: "Electronics",
    subtitle: "Devices & More",
    bg: "bg-lime-200",
  },
  {
    icon: <FaTshirt />,
    title: "Fashion",
    subtitle: "Men & Women",
    bg: "bg-blue-200",
  },
  {
    icon: <FaHome />,
    title: "Home & Kitchen",
    subtitle: "Essentials",
    bg: "bg-pink-200",
  },
  {
    icon: <FaSpa />,
    title: "Beauty",
    subtitle: "Care & More",
    bg: "bg-purple-200",
  },
  {
    icon: <FaGamepad />,
    title: "Toys & Games",
    subtitle: "Fun for All",
    bg: "bg-yellow-200",
  },
];

export default function CategoriesBar() {
  return (
    <div className="w-full bg-white border border-gray-200 rounded-2xl overflow-hidden">
      <div className="flex items-center justify-between">
        {categories.map((item, index) => (
          <div
            key={item.title}
            className={`flex items-center gap-4 px-6 py-5 flex-1 ${
              index !== categories.length - 1
                ? "border-r border-gray-200"
                : ""
            }`}
          >
            <div
              className={`w-12 h-12 rounded-full ${item.bg} flex items-center justify-center text-gray-800 text-xl`}
            >
              {item.icon}
            </div>

            <div>
              <h3 className="font-semibold text-gray-900 text-sm">
                {item.title}
              </h3>
              <p className="text-xs text-gray-500 mt-1">
                {item.subtitle}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}